import { LittlebirdWingMarkIcon } from '@/assets/icons/littlebird-wing-mark';
import { WikiUserAvatar } from '@/features/people-wiki/components/user-avatar';
import { useWikiPersonOfUser } from '@/features/people-wiki/use-wiki-person-of-user';
import { cn } from '@/lib/utils';

import type { TeammateMessageContent } from '@littlebird/action-cards';

export const TeammateCardIcon = ({
  teammate,
  className,
}: {
  teammate: TeammateMessageContent['teammate'];
  className?: string;
}) => {
  const name = useWikiPersonOfUser(teammate.id)?.name ?? teammate.name;
  return (
    <span
      role="img"
      aria-label={`${name}'s Littlebird`}
      className={cn(
        'relative flex size-6 shrink-0 items-center justify-center',
        className
      )}
    >
      <WikiUserAvatar
        userId={teammate.id}
        name={teammate.name}
        className="card-icon-face size-[88%] border-0 text-[0.5625rem] leading-none"
      />
      <span
        aria-hidden
        data-card-icon-badge=""
        className="absolute bottom-0 right-0 flex size-[45%] items-center justify-center rounded-full bg-surface text-foreground ring-1 ring-surface"
      >
        <LittlebirdWingMarkIcon className="size-full" />
      </span>
    </span>
  );
};
